import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {PurchaseOrdersService} from '../../services/purchase-orders.service';
import {CommonService} from '../../services/common.service';

@Component({
  templateUrl: './material-accessories-dialog.component.html'
})
export class MaterialAccessoriesDialogComponent implements OnInit {

  @ViewChild(MatSort, {static: false}) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatPaginator, {static: false}) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  private paginator: MatPaginator;
  private sort: MatSort;
  public accessories: any[];
  public dataSource: MatTableDataSource<any>;
  public displayedColumns: string[];
  public loading: boolean;
  public requestID: number;

  constructor(private matDialog: MatDialog,
              private matDialogRef: MatDialogRef<MaterialAccessoriesDialogComponent>,
              private purchaseOrdersService: PurchaseOrdersService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.loading = true;
    this.requestID = this.data.requestID;
    this.dataSource = new MatTableDataSource<any>([]);
    this.displayedColumns = ['material_id', 'material_description', 'grade', 'is_led_name', 'accessory_category_description', 'value_to_load'];
  }

  public async ngOnInit() {
    this.accessories = await this.purchaseOrdersService.fetchDetailsAccessories(`request/web/${this.requestID}/details/accessories`);
    this.dataSource = new MatTableDataSource<any>(this.accessories);
    this.loading = false;
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  public closeDialog(): void {
    this.matDialogRef.close();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
}
